"use client"

import * as React from "react"
import * as HoverCardPrimitive from "@radix-ui/react-hover-card"
import { classNames } from "../../../utils/classNames"

export const HoverCard = ({ ...props }: React.ComponentProps<typeof HoverCardPrimitive.Root>) => {
    return <HoverCardPrimitive.Root data-slot="hover-card" {...props} />
}

export const HoverCardTrigger = ({ className, ...props }: React.ComponentProps<typeof HoverCardPrimitive.Trigger>) => {
    return (
        <HoverCardPrimitive.Trigger
            data-slot="hover-card-trigger"
            className={classNames(className, "text-inherit")}
            {...props}
        />
    )
}

export const HoverCardContent = ({
    className,
    align = "center",
    sideOffset = 4,
    children,
    ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content>) => {
    return (
        <HoverCardPrimitive.Portal data-slot="hover-card-portal">
            <HoverCardPrimitive.Content
                data-slot="hover-card-content"
                align={align}
                sideOffset={sideOffset}
                className={classNames(classes.content, className)}
                {...props}>
                {children}
                <HoverCardPrimitive.Arrow className="fill-[#111827]" />
            </HoverCardPrimitive.Content>
        </HoverCardPrimitive.Portal>
    )
}

const classes = {
    content:
        "bg-[#111827] text-white text-opacity-90 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[1000] w-96 origin-(--radix-hover-card-content-transform-origin) rounded-lg py-3 px-4 shadow-md outline-hidden",
}
